import React, {useContext, useState} from 'react';
import Icon from '@mdi/react';
import classes from "./Auth.module.scss";
import {observer} from "mobx-react-lite";
import {Context} from "../index";
import {useNavigate} from "react-router";
import {login} from "../http/userAPI";
import {jwtDecode} from "jwt-decode";
import logo from '../assets/logo.png'
import {mdiEye, mdiEyeOff} from '@mdi/js';


const Auth = observer(() => {
    const {user} = useContext(Context);
    const navigate = useNavigate();
    const fromPage = '/things';
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');

    const sIn = async () => {
        try {
            const {data} = await login(email, password);
            localStorage.setItem('token', data.token)
            user.setIsAuth(true)
            user.setUserId(jwtDecode(data.token).issuer_id)
            navigate(fromPage, {replace: true})
        } catch (e) {
            alert('Не верно введен email или пароль')
        }
    }
    const [pass, setPass] = useState(true);
    return (
        <div className={classes.container}>
            <div className={classes.form}>
                <div className={classes.logo_img}>
                    <img src={logo} alt=""/>
                </div>
                <h1>Авторизация</h1>
                <form action={''}>
                    <input className={classes.input}
                           type="email"
                           name={'username'}
                           placeholder={'Введите email'}
                           value={email}
                           onChange={e => setEmail(e.target.value)}/>
                    <div className={classes.wrapperPass}>
                        <input className={classes.inputPass}
                               type={pass ? "password" : "text"}
                               placeholder={'Введите пароль'}
                               value={password}
                               autoComplete={"on"}
                               onChange={e => setPassword(e.target.value)}/>

                        <button className={classes.passBtn}
                                type={"button"}
                                onClick={() => {
                                    pass ? setPass(false) : setPass(true)
                                }}>
                            {pass
                                ? <Icon size={1} path={mdiEyeOff}/>
                                : <Icon size={1} path={mdiEye}/>}
                        </button>
                    </div>
                    <button className={classes.login} type={"button"}
                            onClick={sIn}>Войти
                    </button>
                </form>
            </div>
            <div className={classes.info}>
                <p className={classes.support}>support@faradaydc.com</p>
                <p>FDC LLC</p>
                <p>2024</p>
            </div>
        </div>
    );
});

export default Auth;